import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Orders';
moduleConfig.singleItemTitle = 'Order';
moduleConfig.url = 'orders';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Archive Selected",
        value: "Archive"
    },
    {
        displayName: "Restore Selected",
        value: "Restore"
    }
];

moduleConfig.breadcrumbs = {
  listing: {
    label: moduleConfig.title,
    url: `/${moduleConfig.url}`,
  },
  update: {
    label: "Update",
  },
  create: {
    label: "Create",
  },
  details: {
    label: "Details",
  },
}


export default moduleConfig;